import {adminHttpClient} from "../commons/adminHttpClient";


const getNewsTickerView = (id : string) : Promise<any> => {
    return adminHttpClient.get(`/NewsTickerAudits/View/${id}`);
}
export default getNewsTickerView